import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import {WorkflowNotificationService, WorkflowNotificationUser} from "./workflow-notification.service";
import {WorkflowStepGqlModel} from "../models/workflow.gql-model";
import {handleErrors} from "../../misc/handle-errors.decorator";

export interface WorkflowNotificationDialogModel {
  targetStep?: WorkflowStepGqlModel;
  correctRole?: boolean;
}

@Component({
  templateUrl: "./workflow-notification-dialog.template.pug",
})
export class WorkflowNotificationDialogComponent
  extends DialogComponent<WorkflowNotificationDialogModel, boolean>
  implements WorkflowNotificationDialogModel {
  targetStep: WorkflowStepGqlModel;
  correctRole: boolean;
  users: WorkflowNotificationUser[] = [];
  error: Error;

  static show(dialogService: DialogService, model: WorkflowNotificationDialogModel): Observable<boolean> {
    return dialogService.addDialog(WorkflowNotificationDialogComponent, model, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  @handleErrors()
  async notify() {
    await this.workflowNotificationService.sendNotification(this.targetStep);

    this.close();
  }

  @handleErrors()
  async load() {
    this.users = await this.workflowNotificationService.getUsers(this.targetStep);
  }

  ready() {
    this.load();
  }

  constructor(
    public dialogService: DialogService,
    private workflowNotificationService: WorkflowNotificationService,
  ) {
    super(dialogService);
    this.result = true;
  }
}
